/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Ctrl_Big1_DescInputs */

const en_mk_ctrl_big1_desc = /** @type {(inputs: Mk_Ctrl_Big1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review available usage by feature, task, and agent. Cost figures depend on the data each provider reports.`)
};

const id_mk_ctrl_big1_desc = /** @type {(inputs: Mk_Ctrl_Big1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tinjau pemakaian yang tersedia menurut fitur, tugas, dan agent. Kelengkapan angka biaya mengikuti data dari provider.`)
};

/**
* | output |
* | --- |
* | "Review available usage by feature, task, and agent. Cost figures depend on the data each provider reports." |
*
* @param {Mk_Ctrl_Big1_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_ctrl_big1_desc = /** @type {((inputs?: Mk_Ctrl_Big1_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Ctrl_Big1_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_ctrl_big1_desc(inputs)
	return en_mk_ctrl_big1_desc(inputs)
});